import React, { FC, useMemo } from 'react';

interface IPropertiesSCGWallet {
    fill?: string
}

export const SVGWallet:FC<IPropertiesSCGWallet> = (properties) => {

    const svgColor = useMemo(() => {
        if (properties.fill) return properties.fill

        return '#000'
    }, [properties.fill])

    return <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M31.6667 33.3337H8.33333C6.49238 33.3337 5 31.8413 5 30.0003V15.0003C5 13.1594 6.49238 11.667 8.33333 11.667H31.6667C33.5077 11.667 35 13.1594 35 15.0003V30.0003C35 31.8413 33.5077 33.3337 31.6667 33.3337Z" stroke={svgColor} stroke-width="1.5"/>
        <path d="M27.4993 23.3337C27.0392 23.3337 26.666 22.9605 26.666 22.5003C26.666 22.0402 27.0392 21.667 27.4993 21.667C27.9595 21.667 28.3327 22.0402 28.3327 22.5003C28.3327 22.9605 27.9595 23.3337 27.4993 23.3337Z" fill={svgColor} stroke={svgColor} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M30 11.667V9.33906C30 7.14896 27.924 5.55397 25.8078 6.11827L7.47445 11.0072C6.01528 11.3963 5 12.7178 5 14.228V15.0004" stroke={svgColor} stroke-width="1.5"/>
    </svg>
};